// import logo from './logo.svg';
// import './assets/styles/index.css';
import Header from './layouts/header/Header';
import Footer from './layouts/footer/Footer';
import MainSection from './layouts/main/Main_Section';

function App() {
  return (
    <>
      <Header />
      <MainSection />
      <Footer />
    </>
  );
}

export default App;
